/**
 * @generated SignedSource<<d9980eecfd0a300538d985d30660a602>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Status = "ACTIVE" | "PAUSED" | "%future added value";
export type ToggleJobStatusInput = {
  jobId: any;
};
export type ToggleJobStatusMutation$variables = {
  input: ToggleJobStatusInput;
};
export type ToggleJobStatusMutation$data = {
  readonly toggleJobStatus: {
    readonly job: {
      readonly id: any;
      readonly status: Status;
    };
  };
};
export type ToggleJobStatusMutation = {
  response: ToggleJobStatusMutation$data;
  variables: ToggleJobStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ToggleJobStatusPayload",
    "kind": "LinkedField",
    "name": "toggleJobStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLJob",
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ToggleJobStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ToggleJobStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9eca9ecd037159b63f97749d7ef623b0",
    "id": null,
    "metadata": {},
    "name": "ToggleJobStatusMutation",
    "operationKind": "mutation",
    "text": "mutation ToggleJobStatusMutation(\n  $input: ToggleJobStatusInput!\n) {\n  toggleJobStatus(input: $input) {\n    job {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "25c02b55dd8c0b51daf59060ec4c7f0b";

export default node;
